import { magic } from '@gig/magic-sdk';

function uploadFile(params) {
    return magic.transport.uploadFiles('update-user-document', params.file, params.onProgressChange, params.additionalParams);
}
function createUserDocument(params) {
    return magic.transport.uploadFiles('create-user-document', params.file, params.onProgressChange, params.additionalParams);
}

export { createUserDocument, uploadFile };
